import {
  List,
  ListItem,
  ListItemText,
  IconButton,
  Chip,
  Tooltip,
  Typography,
  Box,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import type { CompanyMember } from '../../../../types/team';

const ROLE_LABELS: Record<CompanyMember['role'], string> = {
  OWNER: 'Власник',
  MANAGER: 'Менеджер',
};

interface MemberListProps {
  members: CompanyMember[];
  currentUserId: number | null;
  isOwner: boolean;
  onRemove: (userId: number) => void;
  onChangeRole: (userId: number, role: 'OWNER' | 'MANAGER') => void;
}

export function MemberList({ members, currentUserId, isOwner, onRemove, onChangeRole }: MemberListProps) {
  if (members.length === 0) {
    return <Typography color="text.secondary">Поки що немає учасників команди.</Typography>;
  }

  return (
    <List disablePadding>
      {members.map((member) => {
        const isSelf = member.userId === currentUserId;
        const nextRole = member.role === 'OWNER' ? 'MANAGER' : 'OWNER';

        return (
          <ListItem key={member.userId} divider>
            <ListItemText
              primary={`${member.name}${isSelf ? ' (ви)' : ''}`}
              secondary={member.email}
              slotProps={{
                primary: { noWrap: true },
                secondary: { noWrap: true },
              }}
              sx={{ minWidth: 0, mr: 1 }}
            />
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexShrink: 0 }}>
              <Chip
                label={ROLE_LABELS[member.role]}
                size="small"
                color={member.role === 'OWNER' ? 'primary' : 'default'}
              />
              {isOwner && !isSelf && (
                <>
                  <Tooltip title={`Зробити ${nextRole === 'OWNER' ? 'власником' : 'менеджером'}`}>
                    <IconButton size="small" onClick={() => onChangeRole(member.userId, nextRole)}>
                      <SwapHorizIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Видалити учасника">
                    <IconButton size="small" color="error" onClick={() => onRemove(member.userId)}>
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </>
              )}
            </Box>
          </ListItem>
        );
      })}
    </List>
  );
}

